import testiImg from "../../assets/images/testimonial/testimonial.png";

export const TESTIMONIALS_DATA = [
  {
    id: 1,
    name: "Basa Annaya",
    description: "UPSC Aspirant",
    review:
      "Vinay sir and Madhu sir have been a huge support throughout my UPSC journey. Their well-structured guidance and mentorship made complex topics easy to grasp. I'm really glad they're starting an institute to help more aspirants like me!",
    image: testiImg,
  },
  {
    id: 2,
    name: "Priya K",
    description: "UPSC Mains Qualified",
    review:
      "The faculty at IAS Jnani are available most of the time, making it easy to clear doubts whenever needed. Their notes helped me immensely in multiple exams, and the way they explain concepts is truly engaging. Highly recommended for CSE aspirants!",
    image: testiImg,
  },
  {
    id: 3,
    name: "Naveen",
    description: "Aspirant - 2025 Attempt",
    review:
      "IAS Jnani’s structured approach helped me stay on track. The faculty's mentorship, combined with detailed notes and engaging explanations, made learning effective. I’m confident about my 2025 attempt thanks to their support!",
    image: testiImg,
  },
  {
    id: 4,
    name: "Manikant Naik",
    description: "Cleared Prelims 2023",
    review:
      "Clearing Prelims felt like a big challenge, but with IAS Jnani’s guidance, it became manageable. Their current affairs coverage and test series were spot-on.",
    image: testiImg,
  },
  {
    id: 5,
    name: "Gagana R Gowda",
    description: "Cleared Mains 2022",
    review:
      "IAS Jnani’s mentorship played a key role in my Mains success. The in-depth discussions, well-structured notes, and consistent faculty support gave me the confidence I needed. So happy they are now launching a full-fledged institute!",
    image: testiImg,
  },
];
